


import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RedirectPage extends Vue {
  public created(): void {
    const paths = this.$route.path.split('/').filter(path => path);
    const { redirect } = this.$route.query;
    if (redirect === undefined) {
      console.log(
        'location.href',
        `/${paths[0]}?redirect=true&return-to=${this.$route.path}`
      );
      location.href = `/${paths[0]}?redirect=true&return-to=${this.$route.path}`;
    }
  }
}
